import { ExportType } from '@components'

import { useCallback } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useDownloadExport } from '../../../hooks/useDownloadExport'
import { getExportDownloadUrl } from '../../../utils/getExportDownloadUrl'

interface DownloadExportFileQueryParams {
  includeVoided?: boolean
  isCustomerOnly?: boolean
  period?: string
  date?: string
}

interface DownloadExportFileArgs {
  exportUrl: string
  type: ExportType
  queryParams?: DownloadExportFileQueryParams
}

export const useDownloadExportFile = () => {
  const { download } = useDownloadExport()
  const { organization } = useUserOrganization()

  const downloadExportFile = useCallback(
    ({ exportUrl, type, queryParams }: DownloadExportFileArgs) => {
      if (organization?.id) {
        const downloadUrl = getExportDownloadUrl({
          exportUrl,
          organizationId: organization?.id,
          type,
          queryParams,
        })

        download(downloadUrl)
      }
    },
    [download, organization?.id],
  )

  return { downloadExportFile }
}
